import React from "react";

function Preview({ template, mediaPreview, varType, showPreview }) {
  const components = template?.components || [];
  const header = components.find((c) => c.type === "HEADER");
  const body = components.find((c) => c.type === "BODY" || c.type === "body");
  const footer = components.find((c) => c.type === "FOOTER");

  const buttonsComp = components.find((c) => c.type === "BUTTONS");
  const buttons = buttonsComp?.buttons || [];
  
  // Check if this is an authentication template
  const isAuthTemplate = template?.category === "AUTHENTICATION" || 
                         buttons.some(btn => btn.type === "otp");
  
  // console.log(mediaPreview, showPreview);

  // var type validation
  function isInvalidVariable(text, varType) {
    if (!text) return false;

    if (varType === "Number") {
      const regex = /{{\D+}}/; // matches {{anything with non-digit}}
      return regex.test(text);
    } else if (varType === "Name") {
      const regex = /{{\d+}}/; // matches {{numbers}}
      return regex.test(text);
    }
    return false;
  }

  // var type validation
  function isInvalidVariable(text, varType) {
    if (!text) return false;

    if (varType === "Number") {
      const regex = /{{\D+}}/; // matches {{anything with non-digit}}
      return regex.test(text);
    } else if (varType === "Name") {
      const regex = /{{\d+}}/; // matches {{numbers}}
      return regex.test(text);
    }
    return false;
  }

  // Generate authentication body text
  function getAuthBodyText() {
    const securityText = body?.add_security_recommendation 
      ? "For your security, do not share this code." 
      : "";
    
    return `{{1}} is your verification code. ${securityText}`.trim();
  }

  // Generate authentication footer text
  function getAuthFooterText() {
    const footerComponent = components.find(c => c.type === "FOOTER");
    if (footerComponent?.code_expiration_minutes) {
      return `This code expires in ${footerComponent.code_expiration_minutes} minutes.`;
    }
    return "";
  }

  return (
    <div className="w-full max-w-md bg-red-100 rounded-lg overflow-hidden shadow-sm">
      {/* Header bar */}
      <div className="bg-gradient-to-r from-gray-200 to-blue-150 p-4 border-b border-black shadow-md">
        <h3 className="text-md p-2 font-medium text-gray-700">Template preview</h3>
      </div>

      {/* Chat container */}
      <div
        className="min-h-[200px] p-4 relative flex items-start"
        style={{
          backgroundImage:
            "url('https://e0.pxfuel.com/wallpapers/722/149/desktop-wallpaper-message-background-whatsapp-message-background.jpg')",
        }}
      >
        {/* Message bubble */}
        <div className="bg-white rounded-lg shadow-sm max-w-xs w-full overflow-hidden p-2">
          {/* HEADER content - only for non-auth templates */}
          {header && !isAuthTemplate && (
            <div className="relative">
              {/* Text header */}
              {header.format === "TEXT" && (
                <div className="px-3 pt-3 pb-2">
                  <p className="text-sm font-semibold break-words">
                    {header.text.split(/({{.*?}})/g).map((part, i) => {
                      // Check if this part is a variable
                      if (/^{{.*}}$/.test(part)) {
                        const isInvalid = isInvalidVariable(part, varType);
                        return (
                          <span
                            key={i}
                            className={
                              isInvalid
                                ? "bg-red-200 text-red-800 px-1 rounded"
                                : ""
                            }
                          >
                            {part}
                          </span>
                        );
                      }
                      // Normal text
                      return part;
                    })}
                  </p>
                </div>
              )}

              {/* Media header */}
              {["IMAGE", "VIDEO", "DOCUMENT"].includes(header.format) && (
                <div className="w-full mb-2">
                  {mediaPreview && showPreview ? (
                    header.format === "IMAGE" ? (
                      <img
                        src={mediaPreview}
                        alt="Uploaded"
                        className="w-full h-40 object-cover rounded"
                      />
                    ) : header.format === "VIDEO" ? (
                      <video
                        src={mediaPreview}
                        className="w-full h-auto object-cover rounded"
                        controls
                      />
                    ) : (
                      <div className="px-3 pt-3 pb-2">
                        <a
                          href={mediaPreview}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline text-sm flex items-center"
                        >
                          <svg
                            className="w-4 h-4 mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                              clipRule="evenodd"
                            />
                          </svg>
                          View Document
                        </a>
                      </div>
                    )
                  ) : (
                    // WhatsApp-style dummy previews
                    <div className="relative w-full">
                      <div
                        className="flex items-center justify-center bg-gray-400 rounded-t-lg"
                        style={{ height: 130 }}
                      >
                        {header.format === "IMAGE" && (
                          <div className="w-12 h-12 bg-white bg-opacity-90 rounded-lg flex items-center justify-center">
                            <svg
                              width="24"
                              height="18"
                              viewBox="0 0 24 18"
                              fill="none"
                              className="text-gray-600"
                            >
                              <path
                                d="M2 16L6 8L12 12L18 4L22 16H2Z"
                                fill="currentColor"
                              />
                              <circle
                                cx="18"
                                cy="4"
                                r="2"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                        )}

                        {header.format === "VIDEO" && (
                          <div className="w-12 h-12 bg-white bg-opacity-90 rounded-full flex items-center justify-center">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              className="text-gray-600 ml-1"
                            >
                              <path
                                d="M8 5V19L19 12L8 5Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                        )}

                        {header.format === "DOCUMENT" && (
                          <div className="w-12 h-12 bg-white bg-opacity-90 rounded-lg flex items-center justify-center">
                            <svg
                              width="20"
                              height="24"
                              viewBox="0 0 20 24"
                              fill="none"
                              className="text-gray-600"
                            >
                              <path
                                d="M12 0H2C0.9 0 0 0.9 0 2V22C0 23.1 0.9 24 2 24H18C19.1 24 20 23.1 20 22V8L12 0Z"
                                fill="currentColor"
                              />
                              <path
                                d="M12 0V8H20"
                                fill="none"
                                stroke="white"
                                strokeWidth="1"
                              />
                              <line
                                x1="4"
                                y1="12"
                                x2="16"
                                y2="12"
                                stroke="white"
                                strokeWidth="1"
                              />
                              <line
                                x1="4"
                                y1="16"
                                x2="16"
                                y2="16"
                                stroke="white"
                                strokeWidth="1"
                              />
                              <line
                                x1="4"
                                y1="20"
                                x2="12"
                                y2="20"
                                stroke="white"
                                strokeWidth="1"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                      <div className="h-3 bg-white rounded-b-lg"></div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* BODY */}
          <div className="px-3 pt-3 pb-2">
            <p className="text-gray-800 text-sm whitespace-pre-line leading-relaxed break-words">
              {isAuthTemplate ? (
                // Authentication template body
                getAuthBodyText().split(/({{.*?}})/g).map((part, i) => {
                  if (/^{{.*}}$/.test(part)) {
                    const isInvalid = isInvalidVariable(part, varType);
                    return (
                      <span
                        key={i}
                        className={
                          isInvalid ? "bg-red-200 text-red-800 px-1 rounded" : ""
                        }
                      >
                        {part}
                      </span>
                    );
                  }
                  return part;
                })
              ) : (
                // Regular template body
                body?.text?.split(/({{.*?}})/g).map((part, i) => {
                  if (/^{{.*}}$/.test(part)) {
                    const isInvalid = isInvalidVariable(part, varType);
                    return (
                      <span
                        key={i}
                        className={
                          isInvalid ? "bg-red-200 text-red-800 px-1 rounded" : ""
                        }
                      >
                        {part}
                      </span>
                    );
                  }
                  return part;
                })
              )}
            </p>
          </div>

          {/* FOOTER */}
          {(footer || isAuthTemplate) && (
            <div className="px-3 pb-2">
              <p className="text-gray-500 text-xs break-words">
                {isAuthTemplate ? getAuthFooterText() : footer?.text}
              </p>
            </div>
          )}

          {/* BUTTONS */}
          {buttons.length > 0 && (
            <div className="border-t border-gray-100">
              {buttons.map((btn, index) => {
                const isLast = index === buttons.length - 1;

                // Handle authentication OTP buttons
                if (btn.type === "otp") {
                  const buttonText = btn.text || "Copy Code";
                  const icon = btn.otp_type === "copy_code" ? "📋" : "🔄";
                  
                  return (
                    <button
                      key={btn.id || index}
                      type="button"
                      className={`block w-full text-center text-blue-600 hover:bg-gray-50 px-4 py-3 text-sm font-medium transition-colors ${
                        !isLast ? "border-b border-gray-100" : ""
                      }`}
                    >
                      {icon} {buttonText}
                    </button>
                  );
                }

                // Handle regular buttons
                const buttonText = btn.text || "Button";

                if (btn.type === "PHONE_NUMBER") {
                  return (
                    <a
                      key={btn.id}
                      href={`tel:${btn.phone_number || ""}`}
                      className={`block w-full text-center text-blue-600 hover:bg-gray-50 px-4 py-3 text-sm font-medium transition-colors ${
                        !isLast ? "border-b border-gray-100" : ""
                      }`}
                    >
                      📞 {buttonText}
                    </a>
                  );
                } else if (btn.type === "URL") {
                  const urlRaw = btn.url || "";
                  const example = btn.example || "value";
                  const urlForPreview = urlRaw.replace(/{{\d*}}/g, example);
                  return (
                    <a
                      key={btn.id}
                      href={urlForPreview}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`block w-full text-center text-blue-600 hover:bg-gray-50 px-4 py-3 text-sm font-medium transition-colors ${
                        !isLast ? "border-b border-gray-100" : ""
                      }`}
                    >
                      🌐 {buttonText}
                    </a>
                  );
                } else {
                  return (
                    <button
                      key={btn.id}
                      type="button"
                      className={`block w-full text-center text-blue-600 hover:bg-gray-50 px-4 py-3 text-sm font-medium transition-colors ${
                        !isLast ? "border-b border-gray-100" : ""
                      }`}
                    >
                      {buttonText}
                    </button>
                  );
                }
              })}
            </div>
          )}

          {/* Timestamp and status */}
          <div className="px-3 pb-2 pt-1">
            <div className="text-xs text-gray-400 text-right mt-auto">
              <span>17:26</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Preview;